import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard from 'components/Software/macOS/InstarVision/Image_Adjust/instarVisionCard01';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Image_Adjust/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Richten Sie Ihren Video-Canvas-Bereich mit einem Klick im Layout-Menü ein. Wählen Sie ein Layout, das Ihren Anforderungen und der Anzahl aktiver Kameras entspricht. Das Layout wird immer auf den Standardwert zurückgesetzt, wenn Sie die Software neu starten. Der Standard Start-Layout kann im Systemmenü eingestellt werden.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Image_Adjust/' locationFR='/fr/Software/macOS/InstarVision/Image_Adjust/' crumbLabel="Image Adjust" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/e8339288777d1cf2978692262ac7079b/29114/Banner_en-InstarVision2-0_Image-Adjust.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAgUlEQVQI15XLsQrCMBjE8e9V7PM5uFns7tDEKeJQncRXcXG0QxBXW1c1gRhD+Uv7AFIPfhw3nNBFCB7eHlKA8ILggMTYGGPIF8XwF1U79PmJ7rtnI/qSUPaDsvGn0kZW145iqZnPppS1Q2R3R6oG2bZIdUP2D+Tg/uDJ1kcmm9Owv8RLwKGMRCecAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e8339288777d1cf2978692262ac7079b/e4706/Banner_en-InstarVision2-0_Image-Adjust.avif 230w", "/de/static/e8339288777d1cf2978692262ac7079b/d1af7/Banner_en-InstarVision2-0_Image-Adjust.avif 460w", "/de/static/e8339288777d1cf2978692262ac7079b/7f308/Banner_en-InstarVision2-0_Image-Adjust.avif 920w", "/de/static/e8339288777d1cf2978692262ac7079b/e1c99/Banner_en-InstarVision2-0_Image-Adjust.avif 1380w", "/de/static/e8339288777d1cf2978692262ac7079b/76ea5/Banner_en-InstarVision2-0_Image-Adjust.avif 1840w", "/de/static/e8339288777d1cf2978692262ac7079b/f696c/Banner_en-InstarVision2-0_Image-Adjust.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/e8339288777d1cf2978692262ac7079b/a0b58/Banner_en-InstarVision2-0_Image-Adjust.webp 230w", "/de/static/e8339288777d1cf2978692262ac7079b/bc10c/Banner_en-InstarVision2-0_Image-Adjust.webp 460w", "/de/static/e8339288777d1cf2978692262ac7079b/966d8/Banner_en-InstarVision2-0_Image-Adjust.webp 920w", "/de/static/e8339288777d1cf2978692262ac7079b/445df/Banner_en-InstarVision2-0_Image-Adjust.webp 1380w", "/de/static/e8339288777d1cf2978692262ac7079b/78de1/Banner_en-InstarVision2-0_Image-Adjust.webp 1840w", "/de/static/e8339288777d1cf2978692262ac7079b/882b9/Banner_en-InstarVision2-0_Image-Adjust.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e8339288777d1cf2978692262ac7079b/81c8e/Banner_en-InstarVision2-0_Image-Adjust.png 230w", "/de/static/e8339288777d1cf2978692262ac7079b/08a84/Banner_en-InstarVision2-0_Image-Adjust.png 460w", "/de/static/e8339288777d1cf2978692262ac7079b/c0255/Banner_en-InstarVision2-0_Image-Adjust.png 920w", "/de/static/e8339288777d1cf2978692262ac7079b/b1001/Banner_en-InstarVision2-0_Image-Adjust.png 1380w", "/de/static/e8339288777d1cf2978692262ac7079b/161ec/Banner_en-InstarVision2-0_Image-Adjust.png 1840w", "/de/static/e8339288777d1cf2978692262ac7079b/29114/Banner_en-InstarVision2-0_Image-Adjust.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/e8339288777d1cf2978692262ac7079b/c0255/Banner_en-InstarVision2-0_Image-Adjust.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "bildeinstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#bildeinstellungen",
        "aria-label": "bildeinstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildeinstellungen`}</h2>
    <InstarVisionCard mdxType="InstarVisionCard" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><strong parentName="p">{`Beachten Sie bitte`}</strong>{`, dass `}<strong parentName="p">{`Einstellungen der Video und Audioqualität`}</strong>{` nur zur bei Kameras zur Verfügung stehen, die über ein INSTAR Kamera Profil zur `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/Camera_List/"
      }}>{`Software hinzugefügt`}</a>{` wurden. Wenn Sie, beispielsweise, eine INSTAR Kamera über das `}<strong parentName="p">{`ONVIF, RTSP oder P2P Profil`}</strong>{` hinzufügen (d.h. beim Hinzufügen die entsprechenden Profile als `}<strong parentName="p">{`IP Kamera Modell`}</strong>{` wählen), stehen Ihnen diese Funktionen `}<strong parentName="p">{`nicht vorhanden`}</strong>{`.`}</p>
    <h3 {...{
      "id": "optionen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#optionen",
        "aria-label": "optionen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Optionen`}</h3>
    <p>{`Die verfügbaren Einstellungsoptionen sind abhängig vom ausgewählten Kameramodell:`}</p>
    <h4 {...{
      "id": "bildeinstellungen-bei-einer-instar-1080p-fullhd-ip-kamera-webui",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#bildeinstellungen-bei-einer-instar-1080p-fullhd-ip-kamera-webui",
        "aria-label": "bildeinstellungen bei einer instar 1080p fullhd ip kamera webui permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildeinstellungen bei einer INSTAR 1080p FullHD IP Kamera (`}<a parentName="h4" {...{
        "href": "/de/Web_User_Interface/1080p_Serie/Multimedia/Video/"
      }}>{`WebUI`}</a>{`)`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/c929c/de_imageadjust_fullhd.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAADV0lEQVQozxXRaU+TBwDA8X6WvdiLzZFJFIaC4xDL0crTh560taX2ogeCSgvUFtSWQldQWIcBtdIhQZGZIIrgFsHBYlzckWbR6ca2d85xCguQUPJf9vsKP4moPoHW4ECts6LT21GorZRU1CAtP45cLiAqREqlMo6VyVCr1Rj0Gox6DfoaPaVlAl63m9e/vmT8zh3+XFxEcmVoluTNeRL99+lLTDCYekb8+g/0Jp9y5cZjHn/3C/3DczR13GJ06jnzP//B/PNXzH//mpmF37k79YzU0BCdnZ2M3b6NRFalQam0oVC5KRfNFMuNtPY9IPHlPJGu67RHwlzoihP+7DLh2GUioSiNrrO0BTroiPZyMdrLjWSSiYkJvhofR9IS68ER6sDZ1omjPY7xYg+W2AhKSyOhZhfdLTp8dgGfU4fPbSfg8eK1OGmwWmgwyLnkt/Lu3TobG5tsbW0hCX8RI3Ktl2B/HE8sgjsWw93ip0ImJeC3kIyZGYhYSHa5GIy3Em0P0R0Okoo3MhyxMdp9mq1/N1l6+zery8tItBY52pMiamsVJpcGr9dCq0eH01CGVSelzixFpyrGaa7gbF01jU4tXpuI11yGVXkYv0fNm9V1/nq7wj8ra0juzf7EzEKahR9/Y+5pmsHUKKnxaSafpLn/bZpg/xNCn39D8NI9mjvHUHkGqPKkUPomqWyYwH7+Aek3a9xcXOfF0sb/y2OEuxMkkqPcmpzDfdpP07nzXB25S6iji2pHDNGVQOEeQGbtIU/RyiGxlRJjFEXzNE0DL1leWmJtdYXNjQ0kuXkHUGqqkcnL0dSosDntqLTVVKtECo7kkJVbRHaBnMPlJygUHeQLNnIrzRyUqskuVqK0t7ObybC3t8fO9g4SlSigEGQcLS3keJWUClkpx6RFGE01VAmV7M/J4qP977Mv6z0+2PchHx84yKEjBeTkF5Kd9yk1Zhu7uxkymQw729tIivI/4YzXQb3Xg8mgQ6wsRSXIKC87iiAcp9bto/ZUG3pPG1pTLQqhGJWiBJNRiUajoK7Bz9TUQ6anH/L1o0dIvB4TZ05ZaXTpsVu0NDhMnDQI2B0m6uttxK/NEB1JExp+RSD1gsDALK5gHy3BC/gCbZwLxxkcvEoymWR4eJj/AI+3WWhGfBw/AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1448d0025125deb0bd8f744fa2dcb4e7/e4706/de_imageadjust_fullhd.avif 230w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/d1af7/de_imageadjust_fullhd.avif 460w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/7f308/de_imageadjust_fullhd.avif 920w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/203bb/de_imageadjust_fullhd.avif 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/1448d0025125deb0bd8f744fa2dcb4e7/a0b58/de_imageadjust_fullhd.webp 230w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/bc10c/de_imageadjust_fullhd.webp 460w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/966d8/de_imageadjust_fullhd.webp 920w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/491b1/de_imageadjust_fullhd.webp 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1448d0025125deb0bd8f744fa2dcb4e7/81c8e/de_imageadjust_fullhd.png 230w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/08a84/de_imageadjust_fullhd.png 460w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/c0255/de_imageadjust_fullhd.png 920w", "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/c929c/de_imageadjust_fullhd.png 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/1448d0025125deb0bd8f744fa2dcb4e7/c0255/de_imageadjust_fullhd.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "bildeinstellungen-bei-einer-instar-720p-hd-ip-kamera-webui",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#bildeinstellungen-bei-einer-instar-720p-hd-ip-kamera-webui",
        "aria-label": "bildeinstellungen bei einer instar 720p hd ip kamera webui permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildeinstellungen bei einer INSTAR 720p HD IP Kamera (`}<a parentName="h4" {...{
        "href": "/de/Web_User_Interface/720p_Serie/Multimedia/Video/"
      }}>{`WebUI`}</a>{`)`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/c929c/de_imageadjust_hd.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAADR0lEQVQoz0XTW0+bBQCA4f4WL7zQSRzZcBswOYx1LaV8/drSA60tpecD5TBLuw5KgHLoCgEGKOlWZJTArJNEgaxeMGJFgyFijFG2SDTeSoQsKBRmXrNd6B94bt68Em2DCZPZidFow2yyo2mwIZXrkcvrUCnrEQQNVdeVVEuViFo9eqMBg9GAzmimSiri9rbwbHeXT7JZft3bQzL90RPSmTyT0yuMT37GzNwWd+5/x3j6G6Zn11n/+kc+yGwQGlhiaW2b/Pd7fLW9S/7bZ3yx+QvZlS3S6TRDQ0NkHz5EUluvQ6txoNL6kIlWqurM3JpYZfJBnvjwfXri/fQOJ+m/M0Z/Yox49yBt3pvEogPEB8boS0yzuLTE8vIy2WwWSXh4FFf3AO7YEK6eJOa+UWyJBTS2NrrDXkYiBkJOgZDbQMjnJOoPELC5abXbaG1UMBbxcFoo8PzwgL//OkLSN5Ugfm+CrqkkvkQcbyKBL9yJrFZKtLOZdMLKTNzG7LCHVPIWQz3djPR3MZdsIxO3k0m2s3/4nN/3D/jjz0MkxmYFRrsKvV2J1dtAsKWJaECPxyTFaZDitt5Ap6nGaZHT7tEQdBvw2dX4rTKaxFKiwUaeHhyz+NsRP+8fIXm8sc365g5bO7tsbu0w+2CBxUer5L7cIZffITKVJzy+TnhklY7BRwi+FHJfhvr315AGV7D05CicnPDPixecHB+/rPwxfSNT3E0vsvj5Bt72Tm7e7iW18Cld8WE07gRq711E34coHKNcESOUihGqzYOI4cd0pnYpFE44Ozvj+CV46fIFNDo1ijoZOqMWh9tJg16NWitSfrWEoncqKS5XUip7jwrRRZngoKTWykVpA8VVGtTOGIXT0/9BrSigEhRcq6lAWS9FrqjhurQSs8VIvVDL+ZIi3jr/OueKXuONc2/y9oWLXLlaTklZBcWX38VocbzC/gMryy7REXDREvBjMRkQa2vQCgpkN64hCEqafCGagjEa/TH0liZUQhVaVTUWswa9ToWntZOVlVXW1lbJ5XJIAn4LHUE7bd5GnDY9rS4LzSYBp8tCS4uD5L0cgws/0D3/lOjcT0RnnuDtmiDS1UsoGuN2f5JUKvXqlsz8PP8CNtdaaVxHlBcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/e4706/de_imageadjust_hd.avif 230w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/d1af7/de_imageadjust_hd.avif 460w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/7f308/de_imageadjust_hd.avif 920w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/203bb/de_imageadjust_hd.avif 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/a0b58/de_imageadjust_hd.webp 230w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/bc10c/de_imageadjust_hd.webp 460w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/966d8/de_imageadjust_hd.webp 920w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/491b1/de_imageadjust_hd.webp 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/81c8e/de_imageadjust_hd.png 230w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/08a84/de_imageadjust_hd.png 460w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/c0255/de_imageadjust_hd.png 920w", "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/c929c/de_imageadjust_hd.png 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a30395c39c316bb1fdd25ed6fa1c5df5/c0255/de_imageadjust_hd.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "bildeinstellungen-bei-einer-instar-vga-ip-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#bildeinstellungen-bei-einer-instar-vga-ip-kamera",
        "aria-label": "bildeinstellungen bei einer instar vga ip kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildeinstellungen bei einer INSTAR VGA IP Kamera`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/dca348638bb77c637a2091d562e913fb/c929c/de_imageadjust_vga.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAADT0lEQVQozzWTzU/TBwBA+7fssMN0yzQgKggMlEpbSvujn79SaEsppR98DWlLhRIppXQVXQdMYasikIJVl2V8iclgq2Rh0bDs4Dozsu28uJiIKy1kb9Fkh3d5h3d7EkHXhKGxDZ3RjtHkQK2zUy0TkdYqkStUyOt1VNXUUS1VImgNGEQjRtGIXjRTJRVwujp4ns1yL53m9709JJ/f3iQ5n2FiapnExNdMz+4Q//IpieQPTN7a5OHjX7gxv0VfZJHF1Sdkftrj8ZMsmR+fs7H9G+nlHZLJJGPRKOmlJSSKej0aTStqrZtawUJVnZn+xAoTdzIMjyUJhkcZHosT/uQ64dh1RgZH6Xb1EgpGGIm8cVOkUovce/AVd9NpJIHYOG2DEZyhKG1DcczD49hiC2ht3Qz43UT9jfQ5VFxyGulzOwh6vHhtTrrsNrpMCq4F2jnKH5B/+Tf51/tIwpMxRr5IMDAZxx0bwRWL4fb7kCmkBHwt3ByzMR2xkhxrZybeT3RokKvhAWbj3cyN2Fm61kv2xWsW/3jFs79eIRFbFIh2NQa7EotLR2eHlaDXgKtRit0opaVZhkFTjaNZRk+7hk6nEbe9AY+lFptQir/DxMtcgT/3C7zY/wfJ2tZTvt3eZWc3y/bOLrfuLJC6v8L697s8yuwyOPUd/k838Y+v8PHofVTuGWTueeovrSLtXKZp6CGFgwP494jCQQ7J5O27DF+d5LNkitQ3W7h6fPRevsL0wgNCkShi+yiCawLBfQNF6zhnhQClQoBq8yiCfx3fTJZ8Pk/h8JBcLoek5EwRGn0Dirpa9KKWVqcDnaGBBq1AeXkxRacrOHFOSWltE5VCG2WqVk7JLRRLdZys0tDgCJEvFDj8P6gRVKhVCs5fqEBZL0WuuECN9CPMzSJqlYySkmO8f+Jdjn/wDu8dP8aHRcWcLT/HqbJKTp6pQLS0cnR09JaDN8HKstP0eJx4vV6aGkXU8ho0qjouXjyPWqXE4enF2jmEyRPC0GxFrapCq66m2axBr1fT3uVjdXWN9fU1Hm1sIOn1mujvtuL3GPC2aPA5Tbia6vA6G+nrspJIrhJZ+JnBuV8Jzj4jeHMT10CCwMAV+oIhLofjTE/PvL1lbm6O/wA2WFrUwD3NcwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/dca348638bb77c637a2091d562e913fb/e4706/de_imageadjust_vga.avif 230w", "/de/static/dca348638bb77c637a2091d562e913fb/d1af7/de_imageadjust_vga.avif 460w", "/de/static/dca348638bb77c637a2091d562e913fb/7f308/de_imageadjust_vga.avif 920w", "/de/static/dca348638bb77c637a2091d562e913fb/203bb/de_imageadjust_vga.avif 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/dca348638bb77c637a2091d562e913fb/a0b58/de_imageadjust_vga.webp 230w", "/de/static/dca348638bb77c637a2091d562e913fb/bc10c/de_imageadjust_vga.webp 460w", "/de/static/dca348638bb77c637a2091d562e913fb/966d8/de_imageadjust_vga.webp 920w", "/de/static/dca348638bb77c637a2091d562e913fb/491b1/de_imageadjust_vga.webp 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/dca348638bb77c637a2091d562e913fb/81c8e/de_imageadjust_vga.png 230w", "/de/static/dca348638bb77c637a2091d562e913fb/08a84/de_imageadjust_vga.png 460w", "/de/static/dca348638bb77c637a2091d562e913fb/c0255/de_imageadjust_vga.png 920w", "/de/static/dca348638bb77c637a2091d562e913fb/c929c/de_imageadjust_vga.png 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/dca348638bb77c637a2091d562e913fb/c0255/de_imageadjust_vga.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      